import { apiFetch } from "./client";
import type { Stats } from "../types";

export async function fetchStats(): Promise<Stats> {
  return apiFetch<Stats>("/stats");
}
